import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _8mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"8mp"}/>
}
